/**
 * example message:
 * 
 * {
	"messageType": "alertNotification",
	"notificationId": 1645479500552,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"amount":100.0,"lossLimitMode":"AMOUNT"},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"LOSS_LIMIT","symbol":"XYZ"},
	"date": "2022-02-21T16:38:21.598-0500",
	"timestamp": "1645479501601"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) amount
 * 2) lossLimitMode
 */
export function lossLimitParser(pluginTemplate) {
    const parsedObject = {
        amount: null,
        lossLimitMode : null //will be either AMOUNT/PERCENT
    }
    if(pluginTemplate) {
        parsedObject.amount=pluginTemplate.amount;
        parsedObject.lossLimitMode=pluginTemplate.lossLimitMode;
    }
    return parsedObject;
}